import { useRef } from "react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import MarketExpansionService from "@app/overviews/market-expansion-dashboard/marketExpansionService";
import { MedicaidProgram } from "@app/overviews/market-expansion-dashboard/shared/MedicaidProgram";
import { MARKET_EXPANSION_QUERY_KEYS } from "@app/overviews/market-expansion-dashboard/hooks/marketExpansionQueryKeys";

export function useGetMedicaidPrograms(stateCode: string | undefined): UseQueryResult<MedicaidProgram[]> {
  const service = useRef(new MarketExpansionService()).current;

  return useQuery<MedicaidProgram[]>({
    enabled: !!stateCode,
    queryFn: ({ signal }) => service.getMedicaidMarketOpportunityPrograms(stateCode!, signal),
    queryKey: [MARKET_EXPANSION_QUERY_KEYS.medicaidPrograms, stateCode],
    // The programs available per state only change quarterly, so there's no need to silently
    // revalidate a state the user is actively looking at - that would risk resetting their
    // in-progress Programs selection back to "all selected" for no visible reason.
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
}
